// extracted by mini-css-extract-plugin
export default {"scrollbar":"sidebar_scrollbar__qGTdb"};